import { Component, computed, inject, input, signal } from '@angular/core';
import { BuildingEquipmentDetailDto } from '@artemis-software/wr-api/model/buildingEquipmentDetailDto';
import { MaintenanceTimerDetailDto, MaintenanceTimerService } from '@artemis-software/wr-api';
import { asyncComputed } from '@/utils/signals/asyncComputed';
import { CurrentUserService } from '@services/current-user.service';

@Component({
  standalone: false,
  selector: 'wr-maintenance-timer-overview',
  templateUrl: './maintenance-timer-overview.component.html',
  styleUrls: ['./maintenance-timer-overview.component.scss'],
})
export class MaintenanceTimerOverviewComponent {

  canCreate = computed(() => this.currentUserService.hasPrivilege('canCreateMaintenanceTimers'));

  readonly buildingEquipment = input<BuildingEquipmentDetailDto>();

  service = inject(MaintenanceTimerService);
  currentUserService = inject(CurrentUserService);

  entities = asyncComputed(() => {
    const buildingEquipment = this.buildingEquipment();
    if (!buildingEquipment) return [];
    return this.service.findAllDetailDtos({
      buildingEquipmentId: buildingEquipment.id, sort: {
        sort: 'nextDate',
        order: 'ASC',
      },
    });
  }, [] as MaintenanceTimerDetailDto[]);

  creatingEntity = signal(false);

  onUpdate(entity: MaintenanceTimerDetailDto): void {
    const entities = [...this.entities()];
    const index = entities.findIndex((e) => e.id === entity.id);
    if (index >= 0) {
      entities[index] = entity;
      this.entities.set(this.sortByNextDate(entities));
    }
  }

  onCreate(entity: MaintenanceTimerDetailDto) {
    this.entities.set(this.sortByNextDate([...this.entities(), entity]));
    this.creatingEntity.set(false);
  }

  onDelete(entity: MaintenanceTimerDetailDto) {
    const entities = [...this.entities()];
    const index = entities.findIndex((e) => e.id === entity.id);
    if (index >= 0) {
      entities.splice(index, 1);
      this.entities.set(entities);
    }
  }

  // The list is loaded sorted by nextDate ASC — keep that order after local
  // replaces (a finished maintenance or changed duration moves nextDate).
  private sortByNextDate(entities: MaintenanceTimerDetailDto[]): MaintenanceTimerDetailDto[] {
    return entities.sort((a, b) => a.nextDate.localeCompare(b.nextDate));
  }
}
